module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jEsIA"))).then(() => parcelRequire('iDabs'));